import React, { useMemo, useState } from 'react';
import TableTitle from '../components/TableTitle';
import { Table } from '../components/Table';
import Container from '../components/Container';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import Tooltip from '../components/Tooltip';
import Dropdown from '../components/Dropdown';

const STATUS = {
  new: {
    icon: <MarkEmailUnreadIcon className="text-orange-500" />,
    description: 'Новая',
  },
  in_progress: {
    icon: <HourglassEmptyIcon className="text-orange-500" />,
    description: 'В работе',
  },
  done: {
    icon: <HowToRegRoundedIcon color="success" />,
    description: 'Завершена',
  },
};

const OPTIONS = [
  {
    status: 'new',
    value: 'Новая',
  },
  { status: 'in_progress', value: 'В работе' },
  { status: 'done', value: 'Завершена' },
];

const MOCK = [
  {
    email: 'email',
    userName: 'userName',
    phone: '+7999000000',
    city: 'city',
    address: 'address',
    company: 'company',
    website: 'website',
    comments: 'comments',
    status: 'new',
  },
];

const IntegrationRequests = () => {
  const [requests, setRequests] = useState(MOCK);

  const handleChangeStatus = (id, newStatus) => {
    setRequests((prev) => prev.map((item) => (item.id === id ? { ...item, status: newStatus } : item)));
  };

  const columns = useMemo(
    () => [
      { key: 'email', title: 'Email' },
      { key: 'userName', title: 'ФИО' },
      // { key: 'phone', title: 'Телефон' },
      // { key: 'city', title: 'Город' },
      // { key: 'address', title: 'Адрес' },
      { key: 'company', title: 'УК' },
      { key: 'website', title: 'Сайт УК' },
      // { key: 'comments', title: 'Комментарии' },
      {
        key: 'status',
        title: 'Статус',
        render: (value) => (
          <div className={'text-center'}>
            <Tooltip text={STATUS?.[value]?.description}>{STATUS?.[value]?.icon}</Tooltip>
          </div>
        ),
      },
      {
        key: 'actions',
        title: 'Изменить статус',
        render: (row) => (
          <div className={'text-center w-[150px]'}>
            <Dropdown
              id={'status'}
              value={row?.status}
              options={OPTIONS}
              inputCb={(e) => handleChangeStatus(row.id, e.target.value)}
              valkey="status"
              optkey="value"
            />
          </div>
        ),
      },
    ],
    []
  );

  return (
    <Container>
      <TableTitle title={'Заявки на интеграцию'} className="max-w-7xl mx-auto" />
      <Table columns={columns} data={requests ?? []} />
    </Container>
  );
};

export default IntegrationRequests;
